import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    getSelectedPayee,
    getTransactionsIsPosting,
} from 'suits-me-npm/selectors';
import { useMakePayment } from 'suits-me-npm/hooks';
import {
    PAYMENT_MAKE_PAYMENT,
    PAYMENT_MAKE_PAYMENT_SUCCESS,
} from 'constants/shared/routes';
import { showModal } from 'actions/modal';
import {
    CONFIRM_AND_SEND_MODAL,
    ERROR_MODAL,
} from 'constants/shared/modalTypes';
import { dispatchHideModal } from 'utils/modals';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import MakePaymentForm from '../presentational/MakePaymentForm';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';

const MakePaymentFormContainer = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const selectedPayee = useSelector(getSelectedPayee);
    const {
        form,
        handleChange,
        handleSubmit,
        isPosting,
        error,
    } = useMakePayment(onSubmit, onError);

    const handleConfirmModal = () => {
        if (!form.Amount.length || form.Amount === '£0.00') {
            dispatch(
                showModal({
                    type: ERROR_MODAL,
                    props: {
                        title: 'Invalid amount',
                        message: 'Please enter an amount larger than £0.00',
                    },
                }),
            );
        } else {
            dispatch(
                showModal({
                    type: CONFIRM_AND_SEND_MODAL,
                    props: {
                        form,
                        selectedPayee,
                        handleSubmit,
                        error,
                        postingSelector: getTransactionsIsPosting,
                        type: 'make-payment',
                    },
                }),
            );
        }
    };

    function onSubmit() {
        dispatchHideModal(dispatch);
        history.push(PAYMENT_MAKE_PAYMENT_SUCCESS, {
            data: {
                amount: form.Amount.substring(1),
                recipient: selectedPayee.payeeName,
            },
        });
    }

    function onError() {
        dispatchHideModal(dispatch);
        history.push(PAYMENT_MAKE_PAYMENT_SUCCESS, {
            data: {
                error,
            },
        });
    }

    useEffect(() => {
        if (!selectedPayee) {
            history.push(PAYMENT_MAKE_PAYMENT);
        }
    }, []);

    return (
        <PageContainer className="make-payment-form-container">
            <SectionTitle
                title={selectedPayee && selectedPayee.payeeName}
                backRoute={PAYMENT_MAKE_PAYMENT}
                additionalText={`${selectedPayee &&
                    selectedPayee.accountNo} | ${selectedPayee &&
                    selectedPayee.sortCode}`}
            />
            <MakePaymentForm
                {...form}
                handleChange={handleChange}
                handleSubmit={handleConfirmModal}
                isPosting={isPosting}
            />
        </PageContainer>
    );
};

export default MakePaymentFormContainer;
